<script setup lang="ts">
import KeywordsPage from '../features/keywords/KeywordsPage.vue';
</script>

<template>
  <KeywordsPage />
</template>
